const ADMIN_USER_STORAGE_KEY = "tecGymAdminUser";

const CLIENT_PRIVILEGES = [
  "Clients",
  "Clients - All Clients",
  "Clients - Active Clients",
  "Clients - Near to Expire Clients",
  "Clients - Inactive Clients",
  "Clients - Go to Details"
];

const HOME_PRIVILEGES = [
  "Home",
  "Home - Total Clients",
  "Home - Active Clients",
  "Home - Inactive Clients"
];

const EMPLOYEE_MANAGEMENT_PRIVILEGES = [
  "Employee Management",
  "Employee Management - User",
  "Employee Management - Role",
  "Employee Management - Attendance",
  "Employee Management - Daily Attendance",
  "Employee Management - Apply Leave",
  "Employee Management - Apply Work From Home",
  "Employee Management - Leave Requests",
  "Employee Management - Work From Home Requests"
];

const APP_ACTIVITY_PRIVILEGES = [
  "App Activity",
  "App Activity - Activity Users",
  "App Activity - User Activity Details"
];

const QUERIES_PRIVILEGES = [
  "Queries",
  "Queries - Pending",
  "Queries - In-Progress",
  "Queries - Solved",
  "Queries - Closed"
];

const MOBILE_APP_PRIVILEGES = [
  "Mobile App",
  "Mobile App - Dashboard",
  "Mobile App - Clients",
  "Mobile App - Requested Feature"
];

export const TECGYM_MOBILE_PACKAGE = "TecGym Mobile";
export const MOBILE_CLIENTS_PATH = "/mobile-clients";
export const MOBILE_DASHBOARD_PATH = "/mobile-dashboard";
export const WEB_DASHBOARD_PATH = "/web-dashboard";
export const WEB_CLIENTS_PATH = "/branches";

function stringifyPackageValue(value) {
  if (value === undefined || value === null) {
    return "";
  }

  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value).trim();
  }

  if (typeof value !== "object") {
    return "";
  }

  const nested = value.branchType ||
    value.gymPackage ||
    value.name ||
    value.packageName ||
    value.title ||
    value.label ||
    value.value;

  return stringifyPackageValue(nested);
}

export function getBranchGymPackage(branch) {
  if (!branch || typeof branch !== "object") {
    return stringifyPackageValue(branch);
  }

  const candidates = [
    branch.branchType,
    branch.gymPackage,
    branch.package,
    branch.packageName,
    branch.clientPackage,
    branch.subscriptionPackage,
    branch.branch?.branchType,
    branch.branch?.gymPackage
  ];

  for (const value of candidates) {
    const packageName = stringifyPackageValue(value);
    if (packageName) {
      return packageName;
    }
  }

  return "";
}

export function isTecGymMobilePackage(value) {
  const packageName = value && typeof value === "object"
    ? getBranchGymPackage(value)
    : stringifyPackageValue(value);
  const normalized = packageName.toLowerCase().replace(/[\s_-]+/g, "");

  return normalized === "tecgymmobile";
}

function readBranchSource(branch) {
  if (!branch || typeof branch !== "object") {
    return "";
  }

  const raw = branch.source ?? branch.Source ?? branch.origin;
  if (raw && typeof raw === "object") {
    return String(raw.name || raw.title || raw.value || raw.label || "").trim();
  }

  return String(raw || "").trim();
}

export function isMobileAppBranch(branch) {
  const source = readBranchSource(branch).toLowerCase();
  if (source === "mobile app") {
    return true;
  }

  return isTecGymMobilePackage(branch);
}

const CONTACT_US_PRIVILEGES = [
  "Contact Us"
];

const LOGIN_LOGS_PRIVILEGES = [
  "Login Logs"
];

const PUBLISHED_PRIVILEGES = [
  "Published"
];

const TECFOLK_ACTIVITY_PRIVILEGES = [
  "Tecfolk Activity"
];

const DATABASE_SHEETS_PRIVILEGES = [
  "DataBase Sheets",
  "DataBase Sheets - Vendor",
  "DataBase Sheets - Technician",
  "DataBase Sheets - Contact Us",
  "DataBase Sheets - Login Logs"
];

const NAV_ROUTE_MODULES = {
  "/dashboard": "Home",
  "/web-dashboard": "Home",
  "/employee-management": "Employee Management",
  "/branches": "Clients",
  "/app-activity": "App Activity",
  "/queries": "Queries",
  "/tecfolk-activity": "Tecfolk Activity",
  "/contact-us": "DataBase Sheets",
  "/login-logs": "DataBase Sheets",
  "/published": "Published",
  "/database-sheets": "DataBase Sheets",
  "/mobile-dashboard": "Mobile App",
  "/feature-requests": "Mobile App",
  "/mobile-clients": "Mobile App"
};

const NAV_ROUTE_ORDER = [
  "/dashboard",
  "/web-dashboard",
  "/branches",
  "/queries",
  "/tecfolk-activity",
  "/mobile-dashboard",
  "/feature-requests",
  "/mobile-clients",
  "/employee-management",
  "/app-activity",
  "/published",
  "/database-sheets"
];

const ROUTE_PREFIX_MODULES = [
  { prefix: "/tecfolk-activity", module: "Tecfolk Activity" },
  { prefix: "/app-activity", module: "App Activity" },
  { prefix: "/contact-us", module: "DataBase Sheets" },
  { prefix: "/login-logs", module: "DataBase Sheets" },
  { prefix: "/published", module: "Published" },
  { prefix: "/database-sheets", module: "DataBase Sheets" },
  { prefix: "/web-dashboard", module: "Home" },
  { prefix: "/mobile-dashboard", module: "Mobile App" },
  { prefix: "/feature-requests", module: "Mobile App" },
  { prefix: "/mobile-clients", module: "Mobile App" },
  { prefix: "/branches/", module: "Clients" },
  { prefix: "/onboarding", module: "Clients" }
];

const ALWAYS_ACCESSIBLE_ROUTES = new Set(["/system-settings"]);
const ADMIN_ONLY_ROUTES = new Set(["/trash"]);

const DASHBOARD_STAT_PRIVILEGES = {
  total: "Home - Total Clients",
  active: "Home - Active Clients",
  inactive: "Home - Inactive Clients"
};

const CLIENT_FILTER_PRIVILEGES = {
  all: "Clients - All Clients",
  active: "Clients - Active Clients",
  NearToExpire: "Clients - Near to Expire Clients",
  Expired: "Clients - Inactive Clients"
};

const CLIENT_FILTER_ORDER = ["all", "active", "NearToExpire", "Expired"];

const QUERY_STATUS_PRIVILEGES = {
  pending: "Queries - Pending",
  inprogress: "Queries - In-Progress",
  solved: "Queries - Solved",
  closed: "Queries - Closed"
};

const QUERY_STATUS_ORDER = ["pending", "inprogress", "solved", "closed"];

const UPDATE_LICENSE_TAB_PRIVILEGES = {
  license: "Go to Details - Update License - License",
  request: "Go to Details - Update License - License Update Request",
  status: "Go to Details - Update License - Request Status"
};

const PRIVILEGE_ALIASES = {
  "database sheets - vendor sheet": "DataBase Sheets - Vendor",
  "contact us": "DataBase Sheets - Contact Us",
  "login logs": "DataBase Sheets - Login Logs"
};

function applyPrivilegeAlias(privilege) {
  const trimmed = String(privilege || "").trim();

  if (!trimmed) {
    return "";
  }

  return PRIVILEGE_ALIASES[trimmed.toLowerCase()] || trimmed;
}

export function normalizePrivilegeValue(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.flatMap(normalizePrivilegeValue);
  }

  if (typeof value === "string") {
    return value
      .split(",")
      .map((privilege) => applyPrivilegeAlias(privilege))
      .filter(Boolean);
  }

  if (typeof value === "object") {
    const privilegeName = value.name ||
      value.title ||
      value.label ||
      value.value ||
      value.privilege ||
      value.priviledge ||
      value.permission ||
      value.module ||
      value.page ||
      value.route;

    return [
      ...(typeof privilegeName === "string" ? [applyPrivilegeAlias(privilegeName)] : normalizePrivilegeValue(privilegeName)),
      ...normalizePrivilegeValue(value.privileges),
      ...normalizePrivilegeValue(value.priviledges),
      ...normalizePrivilegeValue(value.permissions),
      ...normalizePrivilegeValue(value.children),
      ...normalizePrivilegeValue(value.subPrivileges)
    ];
  }

  return [];
}

export function getRoleNameFromObject(role) {
  if (typeof role === "string") {
    return role.trim();
  }

  if (!role || typeof role !== "object") {
    return "";
  }

  return String(
    role.name ||
    role.roleName ||
    role.title ||
    role.designation ||
    role.role ||
    role.role_name ||
    role.adminRole ||
    role.adminRoleName ||
    role.tecgymAdminRole ||
    role.tecgymAdminRoleName ||
    ""
  ).trim();
}

export function extractPrivilegesFromRole(role) {
  if (!role) {
    return [];
  }

  const privilegeSources = [
    role?.privileges,
    role?.priviledges,
    role?.permissions,
    role?.permission,
    role?.rolePrivileges,
    role?.role_privileges,
    role?.access,
    role?.rights,
    role?.modules,
    role?.role?.privileges,
    role?.role?.priviledges,
    role?.data?.privileges,
    role?.data?.priviledges
  ];

  return [...new Set(privilegeSources.flatMap(normalizePrivilegeValue).filter(Boolean))];
}

export function extractRolesList(data) {
  if (!data) {
    return [];
  }

  if (Array.isArray(data)) {
    return data;
  }

  const keys = [
    "response",
    "data",
    "roles",
    "tecgymAdminRoles",
    "adminRoles",
    "result",
    "results",
    "items"
  ];

  for (const key of keys) {
    const value = data[key];
    if (Array.isArray(value)) {
      return value;
    }
    if (value && typeof value === "object") {
      const nestedList = extractRolesList(value);
      if (nestedList.length > 0) {
        return nestedList;
      }
    }
  }

  if (data._id || data.id || data.name || data.roleName) {
    return [data];
  }

  return [];
}

export function extractPrivilegesFromAuthPayload(payload) {
  if (!payload || typeof payload !== "object") {
    return [];
  }

  const privilegeSources = [
    payload.privileges,
    payload.priviledges,
    payload.permissions,
    payload.rolePrivileges,
    payload.role?.privileges,
    payload.role?.priviledges,
    payload.role?.permissions,
    payload.tecgymAdminRole?.privileges,
    payload.tecgymAdminRole?.priviledges,
    payload.user?.privileges,
    payload.user?.priviledges,
    payload.user?.rolePrivileges,
    payload.user?.role?.privileges,
    payload.user?.role?.priviledges,
    payload.user?.tecgymAdminRole?.privileges,
    payload.user?.tecgymAdminRole?.priviledges,
    payload.data?.privileges,
    payload.data?.priviledges,
    payload.data?.role?.privileges,
    payload.data?.role?.priviledges,
    payload.data?.tecgymAdminRole?.privileges,
    payload.data?.tecgymAdminRole?.priviledges,
    payload.response?.privileges,
    payload.response?.priviledges,
    payload.response?.role?.privileges,
    payload.response?.role?.priviledges,
    payload.response?.tecgymAdminRole?.privileges,
    payload.response?.tecgymAdminRole?.priviledges
  ];

  const extracted = [...new Set(privilegeSources.flatMap(normalizePrivilegeValue).filter(Boolean))];

  if (extracted.length > 0) {
    return extracted;
  }

  return extractPrivilegesFromRole(payload.role || payload.tecgymAdminRole || payload.user?.role);
}

function normalizePrivilegeKey(value) {
  return String(value || "").trim().toLowerCase();
}

function readAdminUser() {
  const storedUser = localStorage.getItem(ADMIN_USER_STORAGE_KEY);

  if (!storedUser) {
    return null;
  }

  try {
    return JSON.parse(storedUser);
  } catch {
    return null;
  }
}

function isAdminRoleUser(user = readAdminUser()) {
  if (!user) {
    return false;
  }

  const roleCandidates = [
    user.designation,
    user.role,
    typeof user.role === "object" ? getRoleNameFromObject(user.role) : "",
    user.session?.designation,
    user.session?.role,
    typeof user.session?.role === "object" ? getRoleNameFromObject(user.session.role) : ""
  ];

  return roleCandidates.some(
    (role) => String(role || "").trim().toLowerCase() === "admin"
  );
}

export function canAccessTrash() {
  return isAdminRoleUser();
}

export function getAdminPrivileges() {
  const user = readAdminUser();

  if (!user) {
    return null;
  }

  const storedPrivileges = Array.isArray(user.privileges)
    ? user.privileges.map((privilege) => applyPrivilegeAlias(privilege)).filter(Boolean)
    : [];

  if (isAdminRoleUser(user)) {
    return [...new Set([...storedPrivileges, ...DATABASE_SHEETS_PRIVILEGES])];
  }

  if (!Array.isArray(user.privileges)) {
    return [];
  }

  return [...new Set(storedPrivileges)];
}

export function usesPrivilegeBasedAccess() {
  return getAdminPrivileges() !== null;
}

export function hasModuleAccess(moduleName) {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return false;
  }

  const moduleKey = normalizePrivilegeKey(moduleName);

  if (!moduleKey) {
    return false;
  }

  return privileges.some((privilege) => {
    const privilegeKey = normalizePrivilegeKey(privilege);
    return privilegeKey === moduleKey || privilegeKey.startsWith(`${moduleKey} - `);
  });
}

export function hasExactOrChildPrivilege(requiredPrivilege) {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return false;
  }

  const requiredKey = normalizePrivilegeKey(requiredPrivilege);

  if (!requiredKey) {
    return false;
  }

  return privileges.some((privilege) => {
    const privilegeKey = normalizePrivilegeKey(privilege);
    return privilegeKey === requiredKey || privilegeKey.startsWith(`${requiredKey} - `);
  });
}

export function hasPrivilege(requiredPrivilege) {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return null;
  }

  const requiredKey = normalizePrivilegeKey(requiredPrivilege);

  if (!requiredKey) {
    return false;
  }

  return privileges.some((privilege) => normalizePrivilegeKey(privilege) === requiredKey);
}

export function hasAnyPrivilege(requiredPrivileges = []) {
  return requiredPrivileges.some((privilege) => hasPrivilege(privilege));
}

function getModuleForRoute(route) {
  if (NAV_ROUTE_MODULES[route]) {
    return NAV_ROUTE_MODULES[route];
  }

  const prefixRule = ROUTE_PREFIX_MODULES.find(({ prefix }) => route.startsWith(prefix));
  return prefixRule?.module || null;
}

export function canAccessNavRoute(path) {
  const route = String(path || "").split("?")[0];

  if (ADMIN_ONLY_ROUTES.has(route)) {
    return canAccessTrash();
  }

  if (ALWAYS_ACCESSIBLE_ROUTES.has(route)) {
    return true;
  }

  const moduleName = getModuleForRoute(route);

  if (!moduleName) {
    return true;
  }

  if (hasModuleAccess(moduleName)) {
    return true;
  }

  if (moduleName === "Tecfolk Activity") {
    return hasModuleAccess("Home")
      || hasModuleAccess("Clients")
      || hasModuleAccess("Queries");
  }

  if (route.startsWith("/branches/") && hasModuleAccess("Mobile App")) {
    return true;
  }

  return false;
}

export function getDefaultAccessibleRoute() {
  const firstAllowedRoute = NAV_ROUTE_ORDER.find((route) => canAccessNavRoute(route));

  return firstAllowedRoute || "/system-settings";
}

export function canViewDashboardSection(section) {
  const requiredPrivilege = DASHBOARD_STAT_PRIVILEGES[section];

  if (!requiredPrivilege) {
    return true;
  }

  return hasExactOrChildPrivilege(requiredPrivilege);
}

export function canViewDatabaseSheetsTab(tabId) {
  if (tabId === "vendor" || tabId === "vendor-sheet") {
    return hasExactOrChildPrivilege("DataBase Sheets - Vendor")
      || hasExactOrChildPrivilege("DataBase Sheets - Vendor Sheet")
      || hasModuleAccess("DataBase Sheets");
  }

  if (tabId === "technician") {
    return hasExactOrChildPrivilege("DataBase Sheets - Technician")
      || hasModuleAccess("DataBase Sheets");
  }

  if (tabId === "contact-us") {
    return hasExactOrChildPrivilege("DataBase Sheets - Contact Us")
      || hasExactOrChildPrivilege("Contact Us")
      || hasModuleAccess("Contact Us")
      || hasModuleAccess("DataBase Sheets");
  }

  if (tabId === "login-logs") {
    return hasExactOrChildPrivilege("DataBase Sheets - Login Logs")
      || hasExactOrChildPrivilege("Login Logs")
      || hasModuleAccess("Login Logs")
      || hasModuleAccess("DataBase Sheets");
  }

  return false;
}

export function canViewEmployeeManagementTab(tabId) {
  if (tabId === "roles") {
    return hasExactOrChildPrivilege("Employee Management - Role");
  }

  if (tabId === "leave-requests") {
    return hasExactOrChildPrivilege("Employee Management - Leave Requests");
  }

  if (tabId === "wfh-requests") {
    return hasExactOrChildPrivilege("Employee Management - Work From Home Requests");
  }

  if (tabId === "daily-attendance") {
    return hasExactOrChildPrivilege("Employee Management - Daily Attendance")
      || hasLegacyEmployeeAttendanceAccess();
  }

  if (tabId === "apply-leave") {
    return hasExactOrChildPrivilege("Employee Management - Apply Leave")
      || hasLegacyEmployeeAttendanceAccess();
  }

  if (tabId === "apply-wfh") {
    return hasExactOrChildPrivilege("Employee Management - Apply Work From Home")
      || hasLegacyEmployeeAttendanceAccess();
  }

  if (tabId === "attendance") {
    return hasLegacyEmployeeAttendanceAccess();
  }

  return hasExactOrChildPrivilege("Employee Management - User");
}

function hasLegacyEmployeeAttendanceAccess() {
  return hasExactOrChildPrivilege("Employee Management - Attendance")
    || hasExactOrChildPrivilege("Employee Management - User")
    || hasModuleAccess("Employee Management");
}

export function canViewClientsFilter(filterKey) {
  const requiredPrivilege = CLIENT_FILTER_PRIVILEGES[filterKey];

  if (!requiredPrivilege) {
    return false;
  }

  return hasExactOrChildPrivilege(requiredPrivilege);
}

export function getAllowedClientFilters() {
  return CLIENT_FILTER_ORDER.filter((filterKey) => canViewClientsFilter(filterKey));
}

export function normalizeClientStatusFilter(filter) {
  const normalizedFilter = String(filter || "").toLowerCase();
  if (normalizedFilter === "all") return "all";
  if (normalizedFilter === "expired") return "Expired";
  if (normalizedFilter === "neartoexpire") return "NearToExpire";
  return "active";
}

export function resolveClientStatusFilter(filterParam) {
  const normalizedFilter = normalizeClientStatusFilter(filterParam);
  const allowedFilters = getAllowedClientFilters();

  if (!allowedFilters.length) {
    return normalizedFilter;
  }

  return allowedFilters.includes(normalizedFilter)
    ? normalizedFilter
    : allowedFilters[0];
}

export function canViewQueryStatus(statusId) {
  const requiredPrivilege = QUERY_STATUS_PRIVILEGES[statusId];

  if (!requiredPrivilege) {
    return false;
  }

  return hasExactOrChildPrivilege(requiredPrivilege);
}

export function getAllowedQueryStatuses() {
  return QUERY_STATUS_ORDER.filter((statusId) => canViewQueryStatus(statusId));
}

export function canViewAppActivityUsers() {
  return hasExactOrChildPrivilege("App Activity - Activity Users");
}

export function canViewAppActivityUserDetails() {
  return hasExactOrChildPrivilege("App Activity - User Activity Details");
}

export function canViewUpdateLicenseTab(tabId) {
  const requiredPrivilege = UPDATE_LICENSE_TAB_PRIVILEGES[tabId];

  if (!requiredPrivilege) {
    return false;
  }

  return hasExactOrChildPrivilege(requiredPrivilege);
}

export function getAllowedUpdateLicenseTabs(licenseTabs) {
  return licenseTabs.filter((tab) => canViewUpdateLicenseTab(tab.id));
}

export function canAccessBranchDetails() {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return false;
  }

  return privileges.some((privilege) => {
    const privilegeKey = normalizePrivilegeKey(privilege);
    return privilegeKey.startsWith("go to details - ");
  });
}

export function getAllowedBranchTabsFromPrivileges(branchTabs) {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return null;
  }

  return branchTabs.filter((tab) => hasExactOrChildPrivilege(`Go to Details - ${tab.label}`));
}

export function canViewAppActivityFromPrivileges() {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return null;
  }

  return hasModuleAccess("App Activity");
}

export function canViewQueriesFromPrivileges() {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return null;
  }

  return hasModuleAccess("Queries");
}

export function canViewMobileAppFromPrivileges() {
  const privileges = getAdminPrivileges();

  if (!privileges) {
    return null;
  }

  return hasModuleAccess("Mobile App");
}

export {
  HOME_PRIVILEGES,
  CLIENT_PRIVILEGES,
  EMPLOYEE_MANAGEMENT_PRIVILEGES,
  APP_ACTIVITY_PRIVILEGES,
  QUERIES_PRIVILEGES,
  CONTACT_US_PRIVILEGES,
  LOGIN_LOGS_PRIVILEGES,
  PUBLISHED_PRIVILEGES,
  TECFOLK_ACTIVITY_PRIVILEGES,
  DATABASE_SHEETS_PRIVILEGES,
  MOBILE_APP_PRIVILEGES
};
